const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.pas.forwoodsafety.com',
    USER_TOKEN_URL: 'https://kgk4cf7b87.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://fzka922552.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.staging.pas.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.staging.pas.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.staging.pas.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.pas.forwoodsafety.com',
    WEBSOCKET: 'wss://ko2233x0k2.execute-api.us-west-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
